import FacturasTableWithDeuda from "./FacturasTableWithDeuda";

export {FacturasTableWithDeuda}
export default FacturasTableWithDeuda
